import React from 'react';
import '../../styles/CashRegister.css';

const formatAmount = (value) => {
  if (value === null || value === undefined) return '—';
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatDateLabel = (dateStr) => {
  if (!dateStr) return '—';
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString();
};

const CashRegisterZohoPanel = ({
  session,
  data,
  loading,
  error,
  onRefresh,
}) => {
  if (loading) {
    return (
      <div className="cash-register-zoho-panel">
        <div className="cash-register-loading">Loading Zoho data...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="cash-register-zoho-panel">
        <div className="cash-register-error">{error}</div>
        <button type="button" className="btn-zoho-refresh" onClick={onRefresh}>
          Retry
        </button>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="cash-register-zoho-panel">
        <p className="zoho-panel-hint">Expand this row to load Zoho reconciliation data.</p>
      </div>
    );
  }

  return (
    <div className="cash-register-zoho-panel">
      <div className="zoho-panel-header">
        <div>
          <h3>Zoho Bank Reconciliation</h3>
          <p className="zoho-date-range">
            {formatDateLabel(data.from_date)} – {formatDateLabel(data.to_date)}
          </p>
          <p className="zoho-fetched-at">
            Last fetched: {new Date(data.fetched_at).toLocaleString()}
          </p>
        </div>
        <button type="button" className="btn-zoho-refresh" onClick={onRefresh}>
          Refresh
        </button>
      </div>

      <div className="zoho-metrics">
        <div className="zoho-metric">
          <span className="zoho-metric-label">Actual Balance (Zoho)</span>
          <span className="zoho-metric-value">{formatAmount(data.actual_balance)}</span>
          <span className="zoho-metric-note">Live balance at fetch time</span>
        </div>
        <div className="zoho-metric">
          <span className="zoho-metric-label">Total Receipts (Debits)</span>
          <span className="zoho-metric-value">{formatAmount(data.total_receipts)}</span>
        </div>
        <div className="zoho-metric">
          <span className="zoho-metric-label">Total Withdrawals (Credits)</span>
          <span className="zoho-metric-value">{formatAmount(data.total_withdrawals)}</span>
        </div>
      </div>

      <div className="zoho-session-compare">
        <div className="zoho-compare-item">
          <span>Register opening balance</span>
          <strong>{formatAmount(data.opening_balance ?? session.opening_balance)}</strong>
        </div>
        <div className="zoho-compare-item">
          <span>Register closing balance</span>
          <strong>{formatAmount(data.closing_balance ?? session.closing_balance)}</strong>
        </div>
      </div>

      {data.transactions_scanned > 0 && (
        <p className="zoho-fetch-meta">
          Zoho scan: {data.transactions_in_range} of {data.transactions_scanned} transaction
          {data.transactions_scanned === 1 ? '' : 's'} matched the session dates
          {data.pages_fetched > 0 ? ` (${data.pages_fetched} API page${data.pages_fetched === 1 ? '' : 's'})` : ''}.
          {data.server_date_filter_likely_applied
            ? ' Date filter appears applied by Zoho.'
            : ' Client-side date filter applied (Zoho returned extra rows).'}
        </p>
      )}
    </div>
  );
};

export default CashRegisterZohoPanel;
